import { Autocomplete, InputAdornment, Popper, TextField } from '@mui/material';
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';

const CustomPopper = function (props) {
  return (
    <Popper
      {...props}
      style={{ width: 'fit-content', border: 'none' }}
      placement="bottom-start"
    />
  );
};

const searchCode = {
  width: '50%',
  minWidth: '440px',
  maxWidth: '500px',
};

const CustomAutoComplete = ({
  getOptionLabel,
  id,
  inputIcon,
  inputPlaceHolder,
  onChange,
  onClear,
  onInputChange,
  options,
  value,
  clearOnBlur = true,
}) => {
  return (
    <Autocomplete
      disablePortal
      PopperComponent={CustomPopper}
      id={id}
      getOptionLabel={getOptionLabel}
      options={options || []}
      ListboxProps={{ style: { maxHeight: '30vh' } }}
      sx={searchCode}
      value={value}
      freeSolo
      popupIcon={''}
      onChange={onChange}
      onInputChange={onInputChange}
      clearOnBlur={clearOnBlur}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={inputPlaceHolder}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start" style={{ margin: '1px' }}>
                {inputIcon}
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{
                  visibility: value ? 'visible' : 'hidden',
                  cursor: 'pointer',
                }}
                onClick={onClear}>
                <ClearIcon fontSize="small" />
              </InputAdornment>
            ),
            style: {
              padding: '2px 10px',
            },
          }}
        />
      )}
    />
  );
};

export default CustomAutoComplete;
